import { Color } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

export const UnverifiedWarning = createSvgIcon(
  'UnverifiedWarning',
  <>
    <path
      d="M24.8103 24C42.4044 -1.90735e-06 73.1539 -0.672002 85.0539 17.776C94.3867 32.304 103.344 24.264 115.763 39.68C124.297 50.24 120.65 70.088 98.2974 73.08C69.939 76.848 80.4315 57.2 31.2881 72.072C12.2226 77.856 0.290646 66.288 0.0107412 54.872C-0.39712 38.32 10.8631 43.016 24.8103 24Z"
      fill="#FFF9E5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.0024 71.2H95.9861C97.7535 71.2 99.185 69.768 99.185 68V3.99999C99.185 2.23199 97.7535 0.799988 95.9861 0.799988H48.0024C46.235 0.799988 44.8035 2.23199 44.8035 3.99999V68C44.8035 69.768 46.235 71.2 48.0024 71.2Z"
      fill={Color.White}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.4196 72H95.4185C97.8097 72 99.761 70.056 99.761 67.688V4.312C99.761 1.944 97.8097 0 95.4185 0H48.3144C45.9233 0 43.9719 1.944 43.9719 4.312V35.2H45.7073V4.312C45.7073 2.888 46.8829 1.728 48.3144 1.728H95.4185C96.85 1.728 98.0256 2.896 98.0256 4.312V67.688C98.0256 69.112 96.85 70.272 95.4185 70.272H68.4196V72Z"
      fill={Color.Silver500}
    />
    <path
      d="M88.5408 15.2H56.4877C56.0078 15.2 55.616 14.808 55.616 14.336V12.608C55.616 12.136 56.0078 11.744 56.4877 11.744H88.5488C89.0286 11.744 89.4205 12.136 89.4205 12.608V14.336C89.4125 14.808 89.0206 15.2 88.5408 15.2Z"
      fill={Color.Silver500}
    />
    <path
      d="M79.064 25.392H56.4877C56.0078 25.392 55.616 25 55.616 24.528V22.8C55.616 22.328 56.0078 21.936 56.4877 21.936H79.072C79.5518 21.936 79.9437 22.328 79.9437 22.8V24.528C79.9357 25.008 79.5438 25.392 79.064 25.392Z"
      fill={Color.Silver400}
    />
    <path
      d="M20.4118 75.112C19.1562 77.28 20.7237 80 23.2268 80H63.8371C66.3482 80 67.9077 77.28 66.6521 75.112L46.355 40.024C45.0994 37.856 41.9725 37.856 40.7169 40.024L20.4118 75.112ZM45.8911 71.376C45.8911 72.68 44.8355 73.736 43.5319 73.736C42.2284 73.736 41.1727 72.68 41.1727 71.376C41.1727 70.072 42.2284 69.016 43.5319 69.016C44.8355 69.016 45.8911 70.072 45.8911 71.376ZM45.8911 63.56C45.8911 64.864 44.8355 65.92 43.5319 65.92C42.2284 65.92 41.1727 64.864 41.1727 63.56V53.952C41.1727 52.648 42.2284 51.592 43.5319 51.592C44.8355 51.592 45.8911 52.648 45.8911 53.952V63.56Z"
      fill={Color.Yellow400}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M89.0204 43.432L91.6675 46.08L85.9175 51.816L91.6675 57.552L89.0204 60.2L83.2704 54.464L77.5203 60.2L74.8652 57.552L80.6153 51.816L74.8652 46.08L77.5203 43.432L83.2704 49.168L89.0204 43.432Z"
      fill={Color.Silver500}
    />
  </>,
  { viewBox: '0 0 120 80', style: { width: 120, height: 80 } },
);

export const UnverifiedWarningDarkIcon = createSvgIcon(
  'UnverifiedWarningDark',
  <svg
    width="270"
    height="100"
    viewBox="0 0 270 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M91.0234 30C113.023 1.14441e-05 151.473 -0.839989 166.353 22.22C178.023 40.38 189.223 30.33 204.753 49.6C215.423 62.8 210.863 87.61 182.913 91.35C147.453 96.06 160.573 71.5 99.1234 90.09C75.2834 97.32 60.3634 82.86 60.0134 68.59C59.5034 47.9 73.5834 53.77 91.0234 30Z"
      fill="#33200A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M120.023 89H180.023C182.233 89 184.023 87.21 184.023 85V5C184.023 2.79 182.233 1 180.023 1H120.023C117.813 1 116.023 2.79 116.023 5V85C116.023 87.21 117.813 89 120.023 89Z"
      fill="#151B22"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M145.553 90H179.313C182.303 90 184.743 87.57 184.743 84.61V5.39C184.743 2.43 182.303 0 179.313 0H120.413C117.423 0 114.983 2.43 114.983 5.39V44H117.153V5.39C117.153 3.61 118.623 2.16 120.413 2.16H179.313C181.103 2.16 182.573 3.62 182.573 5.39V84.61C182.573 86.39 181.103 87.84 179.313 87.84H145.553V90Z"
      fill="#47505B"
    />
    <path
      d="M170.713 19H130.633C130.033 19 129.543 18.51 129.543 17.92V15.76C129.543 15.17 130.033 14.68 130.633 14.68H170.723C171.323 14.68 171.813 15.17 171.813 15.76V17.92C171.803 18.51 171.313 19 170.713 19Z"
      fill="#47505B"
    />
    <path
      d="M158.863 31.74H130.633C130.033 31.74 129.543 31.25 129.543 30.66V28.5C129.543 27.91 130.033 27.42 130.633 27.42H158.873C159.473 27.42 159.963 27.91 159.963 28.5V30.66C159.953 31.26 159.463 31.74 158.863 31.74Z"
      fill="#30373D"
    />
    <path
      d="M85.5234 93.89C83.9534 96.6 85.9134 100 89.0434 100H139.823C142.963 100 144.913 96.6 143.343 93.89L117.963 50.03C116.393 47.32 112.483 47.32 110.913 50.03L85.5234 93.89ZM117.383 89.22C117.383 90.85 116.063 92.17 114.433 92.17C112.803 92.17 111.483 90.85 111.483 89.22C111.483 87.59 112.803 86.27 114.433 86.27C116.063 86.27 117.383 87.59 117.383 89.22ZM117.383 79.45C117.383 81.08 116.063 82.4 114.433 82.4C112.803 82.4 111.483 81.08 111.483 79.45V67.44C111.483 65.81 112.803 64.49 114.433 64.49C116.063 64.49 117.383 65.81 117.383 67.44V79.45Z"
      fill={Color.Yellow300}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M171.313 54.29L174.623 57.6L167.433 64.77L174.623 71.94L171.313 75.25L164.123 68.08L156.933 75.25L153.613 71.94L160.803 64.77L153.613 57.6L156.933 54.29L164.123 61.46L171.313 54.29Z"
      fill="#47505B"
    />
  </svg>,
  { viewBox: '0 0 120 80', style: { width: 120, height: 80 } },
);
